import React, { Component } from 'react';
import { Row,FormGroup,FormControl } from 'react-bootstrap';
import Logo from '../../Helper/Logo/logo';
import validations from '../../Helper/Validations';
import Back from "../../Helper/Back/back";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
    disabledButton: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none',
        opacity:0.6,
        '&:hover':{
            backgroundColor:'#851679',
            opacity:0.6,
            cursor:'auto'
        }
    },
};

class NameSection extends Component {
    constructor(props){
        super(props);
        this.state={
            lblErrorMsg:'',
            data:{},
        }
    }

    componentWillMount() {
        if (this.props.data) {
            const {data} = this.props;
            if (Object.keys(data).length > 0) {
                this.setState({
                    data
                })
            }
        }
    }
    checkEmpty=()=>{
        let {data,lblErrorMsg} = this.state;
        return (data.Name!==undefined && data.Name!=="" && lblErrorMsg==="")
    };

    handleChange=(e)=>{
        this.setState({
            lblErrorMsg:''
        });
        const { name,value } = e.target;
        const { data } = this.state;
        let msg = validations.ValidateName(value);
        this.setState({
            lblErrorMsg: msg
        });
        data[name]=value;
        this.setState({data})
    };
    onNext=()=>{
        if(this.checkEmpty()) {
            this.props.next({...this.state.data,Name:this.state.data.Name.trim()});
        }
    };
    onPrevious=()=>{
        this.props.onPrevious(this.state.data);
    };

    render(){
        const { lblErrorMsg,data } = this.state;
        const {classes} = this.props;
        return(
            <section className="container">
                <Row>
                    <div className="col-12 text-center">
                        <Back onPrevious={this.onPrevious}/>
                        <Logo/>
                    </div>
                    <FormGroup className="col-12">
                        <h2 className='subHeading'>Hi, what may we call you?</h2>
                        <div className="error">
                            {
                                (lblErrorMsg!=='')?<span>{lblErrorMsg}</span>:<span/>
                            }
                        </div>
                        <div className="form-group">
                            <FormControl type="text" placeholder="Enter your full name"
                                         name="Name" autoComplete="off"
                                         value={data.Name}
                                         onChange={this.handleChange}
                                         onKeyDown={(e)=>{
                                           if(e.keyCode===13)
                                             this.onNext()
                                         }}
                            />
                        </div>
                        <div className="form-group mt-50">
                            <p>
                                By continuing I agree that I have read and accepted the
                                <a href="https://www.ubme.com/terms.html"> <u>Terms of use</u></a> and <a href="https://www.ubme.com/privacy.html"><u>Privacy Policy</u></a>
                            </p>
                        </div>
                        <FormGroup className="text-right mt-50">
                            <Button className={(this.checkEmpty())?classes.Button:classes.disabledButton}
                                    color={'primary'}
                                    variant={'contained'}
                                    onClick={this.onNext}>Next</Button>
                        </FormGroup>
                    </FormGroup>
                </Row>
            </section>
        )
    };

}
export default withStyles(styles)(NameSection);